/**
 * Sort event references by explicit order, then date, day label, and entity name.
 * Missing values are deliberately pushed behind explicit values.
 */
export function sortEventEntities(items = [], entityById = {}) {
  return [...items].sort((a, b) => {
    const aOrder = a.order == null ? Number.POSITIVE_INFINITY : a.order;
    const bOrder = b.order == null ? Number.POSITIVE_INFINITY : b.order;

    if (aOrder !== bOrder) return aOrder - bOrder;
    if (a.date && b.date && a.date !== b.date) return a.date.localeCompare(b.date);
    if (a.date && !b.date) return -1;
    if (!a.date && b.date) return 1;

    const dayComparison = (a.dayLabel || '').localeCompare(b.dayLabel || '');
    if (dayComparison) return dayComparison;

    const aName = a.titleOverride || entityById[a.entityId]?.name || '';
    const bName = b.titleOverride || entityById[b.entityId]?.name || '';
    return aName.localeCompare(bName);
  });
}

export function publishedChapters(event) {
  return (event.chapters || [])
    .filter((chapter) => chapter.status === 'published')
    .sort((a, b) => a.chapterNumber - b.chapterNumber);
}

export function isRetreatStoryAvailable(event) {
  return event.status === 'published' && publishedChapters(event).length > 0;
}

export function isRetreatStoryComplete(event) {
  const chapters = event.chapters || [];
  return chapters.length > 0 && chapters.every((chapter) => chapter.status === 'published');
}
